import "./SaleMediaPropertyManager.scss";

import { Grid } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import Iframe from 'react-iframe'

import { PropertyType } from "../../backend/types/utils";
import { CreatePropertyManageable } from "../../store/property/types";
import { CreateSaleManageable, SaleManageable } from "../../store/sale/types";
import { Mode } from "../../utils/utility";
import { PropertyField, PropertyInputTypeKey } from "../input/fields/PropertyField";
import { SubformProps } from "../SubformProps";

export interface SaleMediaPropertyManagerProps extends SubformProps<CreateSaleManageable | SaleManageable> {
  id: string;
  mode: Mode;
}

export const SaleMediaPropertyManager = (props: SaleMediaPropertyManagerProps) => {
  // Props
  const {
    errors,
    id,
    mode,
    setFieldValue,
    touched,
    values,
  } = props;

  // Hooks
  const { t } = useTranslation();

  // Options
  const mediaPropertyIndex = values[id]?.findIndex((property: CreatePropertyManageable) => property.type === PropertyType.MEDIA);
  const property = mediaPropertyIndex >= 0 ? values[id][mediaPropertyIndex] : null;

  const setPropertySubfield = (
    id:string, index: number, subkey: string, value: string
  ) => {
    values[id][index][subkey] = value;
    setFieldValue(
      id,
      values[id]
    );
  }

  const setProperty = (
    id:string, index: number, value: any
  ) => {
    values[id][index] = value;
    setFieldValue(
      id,
      values[id]
    );
  }

  const isYoutubeLink = property?.value?.includes("https://www.youtube.com/") || false;
  const isGoogleMapsLink = property?.value?.includes("https://www.google.com/maps/") || false;
  const isAllowedLink = isYoutubeLink || isGoogleMapsLink;

  const element = new DOMParser().parseFromString(
    property?.value || "",
    "text/html"
  )?.getElementsByTagName('iframe')?.[0];

  const url = element?.getAttribute('src') || "";

  return (
    <Grid container direction="column" spacing={3} item>
      {property && (mode === Mode.Edit || property.key && property.value) &&
      <React.Fragment>
        <Grid item>
          <PropertyField
            id={"key" as PropertyInputTypeKey}
            values={property}
            errors={errors?.[mediaPropertyIndex] || {}}
            touched={touched?.[mediaPropertyIndex] || {}}
            setFieldValue={(
              subkey: string, value: any
            ) => setPropertySubfield(
              id,
              mediaPropertyIndex,
              subkey,
              value
            )}
            setValues={(values: any) => setProperty(
              id,
              mediaPropertyIndex,
              values
            )}
            mode={mode}
            variant="filled"
            placeholder={t("Media Title")}
            className="sale-description-title"
          />
        </Grid>

        <Grid item className={mode === Mode.View ? "iframe" : ""}>
          {mode === Mode.Edit &&
          <PropertyField
            id={"value" as PropertyInputTypeKey}
            values={property}
            errors={errors?.[mediaPropertyIndex] || {}}
            touched={touched?.[mediaPropertyIndex] || {}}
            setFieldValue={(
              subkey: string, value: any
            ) => setPropertySubfield(
              id,
              mediaPropertyIndex,
              subkey,
              value
            )}
            setValues={(values: any) => setProperty(
              id,
              mediaPropertyIndex,
              values
            )}
            mode={mode}
            variant="filled"
            placeholder={t("Media Value")}
          />
          ||
          isAllowedLink &&
          <Iframe
            url={url}
            className="iframe"
          />
          }
        </Grid>
      </React.Fragment>
      }
    </Grid>
  );
}